export const DEALERS_SLICE_PREFIX = 'DEALERS';
export const FETCH_DEALERS_ACTION_TYPE = `${DEALERS_SLICE_PREFIX}_FETCH`;
